module.exports = __webpack_public_path__ + "a09056a59eae7c4236d82d519803826d.png";